import { render, staticRenderFns } from "./addtask.vue?vue&type=template&id=9261dc06"
import script from "./addtask.vue?vue&type=script&lang=js"
export * from "./addtask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports